import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FullstoryUtil from 'fullstory_util';

import Paginator from 'react-paginate';
import { ResponsiveCheck } from 'core/providers/Responsive';
import { parseQuery, serialize } from 'core/utils';
import PaginationStyles from './PaginationStyles';

const breakLabelStyle = {
	border: 0,
	margin: 0,
	width: "20px",
	backgroundColor: "inherit"
};

export default class Pagination extends Component {
	static propTypes = {
		curPage: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]).isRequired,
		pageCount: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]).isRequired,
		urlParams: PropTypes.string,
		requestPath: PropTypes.string,
		onPageChange: PropTypes.func,
	};

	handlePageClick = (page) => {
		FullstoryUtil.sendEvent('newPagination');

		const { getQuery, handleHrefBuilder } = this;
		const { onPageChange } = this.props;
		const { selected } = page; // 0-based index of chosen page
		const nextPage = selected + 1;

		if (onPageChange) {
			return onPageChange(getQuery(nextPage));
		}

		window.location.href = handleHrefBuilder(nextPage);
	};

	getQuery = (pageNum) => {
		const queryParams = parseQuery(this.props.urlParams) || {};
		// Update the page num:
		queryParams["page"] = pageNum;
		// Inline with what `search_page_link` does, get rid of `q`
		delete queryParams["q"];

		return `?${serialize(queryParams)}`;
	}

	handleHrefBuilder = (pageNum) => {
		const { requestPath } = this.props;
		const queryString = this.getQuery(pageNum);
		const pathName = requestPath ? requestPath : window.location.pathname;
		return `${pathName}${queryString}`;
	}

	render() {
		const curPage = parseInt(this.props.curPage);
		const pageCount = parseInt(this.props.pageCount);
		if (pageCount < 2) return null;

		return (
			<ResponsiveCheck>
				{({ isMobile }) => (
					<>
						<PaginationStyles />
						<Paginator
							pageCount={pageCount}
							pageRangeDisplayed={isMobile ? 2 : 5}
							marginPagesDisplayed={1}
							breakLabel={<div style={breakLabelStyle}>...</div>}
							onPageChange={this.handlePageClick}
							activeClassName={"active"}
							containerClassName={"reactPagination"}
							previousClassName={curPage === 0 ? 'disabled' : ''}
							nextClassName={this.props.curPage === this.props.pageCount ? 'disabled' : ''}
							forcePage={curPage - 1}
							nextLabel={isMobile ? `>` : 'Next >'}
							previousLabel={isMobile ? `<` : '< Previous'}
							hrefBuilder={this.handleHrefBuilder}
						/>
					</>
				)}
			</ResponsiveCheck>
		);
	}
}
